import Vue from 'vue';
export default Vue.extend({
  name: 'SystemMonitor',
  computed: {
    serviceWorkerReady() {
      var str = this.$store.state.serviceWorkerReady ? 'Ready' : 'Not Ready';
      return "Service Worker is ".concat(str);
    }

  }
});